module.exports = __webpack_public_path__ + "static/media/frog.c2e0d290.svg";